import { Component } from '@angular/core';
import { FieldArrayType, FormlyFormBuilder } from '@ngx-formly/core';
import { BaseCRUDComponent } from '../baseCRUD.component';

@Component({
  selector: 'formly-repeat-section',
  styleUrls: ['repeat-section.component.css'],
  template: `
    <strong>{{to?.label}}</strong><hr />
    <div *ngFor="let fl of field.fieldGroup; let i = index;" class="repeat-section">
    <strong>
    {{to?.innerLabel}} {{i+1}} 
    </strong>
    <hr>
      <formly-field 
      [field]="fl"
      [options]="options"></formly-field>
      <div *ngIf="!formState?.disabled">
        <button class="btn btn-danger mb-1" *ngIf="field?.fieldGroup?.length > 1 && status =='RG'" type="button" (click)="remove(i)">{{ 'GENERIC.REMOVE' | translate }}</button>
    </div>
    </div>
    <button class="btn btn-primary mb-1 float-right" type="button" [disabled]="model?.length>=to?.length" *ngIf="status =='RG' && !formState?.disabled" (click)="add();">{{ to?.addButton }}</button>
  `,
})
export class RepeatTypeComponent extends FieldArrayType {
  status: string;
  ngOnInit(){    
    this.status = localStorage.getItem('status')
    Object.keys(this.form.controls).map((rr,index)=>{
      if(this.form.controls[rr]['controls']){
          this.form.controls[rr]['controls'].map((rr,index)=>{
            Object.keys(rr.controls).map((tt, i)=> {
              if(tt.includes('IsValid') && rr.controls[tt].value == true){
                if(this.status != 'RG'){
                  rr.controls[tt.replace('IsValid','')].disable();
                }
                else{
                  rr.controls[tt.replace('IsValid','')].disable();
                }
              }
              else if(tt.includes('IsValid') && rr.controls[tt].value != true){
                if(this.status == 'RG'){
                  rr.controls[tt.replace('IsValid','')].enable();
                }
                else{
                  rr.controls[tt.replace('IsValid','')].disable();
                }
              }
            })
        
      })}  })
  
}
}
